import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { apiGetPolicyInfo } from "utils/API/TrxNowAPI";
import { PolicyLookupSpinner } from "webapp/components/PolicyLookupSpinner";
import "./CIBCMemberInformationForm.scss";
import PPUConsentScreen from "../PPUConsentScreen/PPUConsentScreen";
import { devLog } from "utils/devLog";

const policyMap = new Map();
function CIBCMemberInformationForm(props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchValue, setSearchValue] = useState(props.currState.MemberLookup.memberRef);

  // const [last8Vin] = useState(props.currState.MemberLookup.last8Vin);
  // const [decalNumber] = useState(props.currState.MemberLookup.decalNumber);
  const [memberNumber] = useState(props.currState.MemberLookup.memberNumber);
  const [make] = useState(props.currState.MemberLookup.make);
  const [model] = useState(props.currState.MemberLookup.model);
  const [year] = useState(props.currState.MemberLookup.year);
  const [color] = useState(props.currState.MemberLookup.color);
  const [firstName] = useState(props.currState.MemberLookup.firstName);
  const [lastName] = useState(props.currState.MemberLookup.lastName);

  const [fullName] = useState(firstName + " " + lastName);
  const [fullNameProps] = useState(props.currState.FirstName + " " + props.currState.LastName);
  const [phoneNum] = useState(props.currState.MemberLookup.phoneNum);

  const [searchType, setSearchType] = useState(props.currState.MemberLookup.searchType);
  const [memberInfo, setMemberInfo] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [selectedMember, setSelectedMember] = useState(undefined);
  const [selectAddNew, setSelectedAddNew] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [partnerCode, setPartnerCode] = useState(props.currState.localGroup);

  useEffect(() => {
    devLog("CIBCMemberInformationForm currState", props.currState);
  }, [props.currState]);

  // let fullNameProps = props.currState.FirstName + props.currState.LastName;
  // fullNameProps = fullNameProps.toUpperCase();

  // useEffect(() => {
  //   devLog("props", props);
  //   onSubmit();
  // }, []);

  const onLoad = (success) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(success);
    }
  };

  const onSubmit = (e) => {
    setError("");
    // e.preventDefault();
    // devLog("Execute policy search...", searchValue);

    if (policyMap.has(searchValue)) {
      setMemberInfo(policyMap.get(searchValue));
      setLoading(false);
      onLoad(true);
      return;
    }

    setLoading(true);
    //Lookup: Callout
    apiGetPolicyInfo({
      data: {
        providerRef: props.currState.providerRef,
        searchType: searchType,
        // decalNumber: decalNumber,
        memberNumber: memberNumber,
        // last8Vin: last8Vin,
        firstName: firstName,
        lastName: lastName,
        partnerCode: partnerCode,
      },
      companyParams: props.currState.currentCompanyParams,
    })
      //Lookup: Success
      .then((json) => {
        const data = json?.data || {};
        const { memberInfo: nextMemberInfo, contactInfo, error: apiError } = data;
        const hasMemberInfo = typeof nextMemberInfo === "object";
        const hasContactInfo = typeof contactInfo === "object";
        const hasContacts = hasContactInfo && contactInfo.length > 0;

        const fail = (message, clearCache = false) => {
          setError(message);
          if (clearCache) {
            policyMap.delete(searchValue);
          }
          onLoad(false);
        };

        if (hasMemberInfo && hasContactInfo) {
          if (!apiError) {
            setMemberInfo(nextMemberInfo);
            setContacts(contactInfo);
            onLoad(true);
          } else {
            fail(apiError.message);
          }
        } else if (hasContacts) {
          if (!apiError) {
            setMemberInfo([]);
            setContacts(contactInfo);
            onLoad(true);
          } else {
            fail(apiError.message);
          }
        } else if (typeof apiError === "object") {
          fail(apiError.message, true);
        } else {
          fail(t("APIA.PolicyInformation.UnableToFindMember"), true);
        }

        setLoading(false);
      })

      //Lookup: Failed
      .catch((e) => {
        devLog("error", e);
        setLoading(false);
        setError(t("APIA.PolicyInformation.UnableToFindMember"));
        onLoad(false);
      });
  };
  const onUserBack = (e) => {
    // e.preventDefault();
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  const onSelect = (contact) => {
    // devLog("onSelect", contact);
    setSelectedMember(contact);
    setSelectedAddNew(false);
    if (!contact) {
      return;
    }
    if (typeof props.onSelect === "function") {
      // devLog("memberInfo", memberInfo);
      // devLog("contact", contact);
      props.onSelect(memberInfo, contact);
    }
  };

  const onSelectAddNew = (member) => {
    // devLog("onSelectNew", member);
    setSelectedAddNew(true);
    setSelectedMember(member);
    if (!member) {
      return;
    }
    if (typeof props.onSelectNew === "function") {
      props.onSelectNew(memberInfo, member);
    }
  };

  const [selectedValue, setSelectedValue] = useState("");

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const [checkDuplicateName, setCheckDuplicateName] = useState(false);
  const checkDuplicateContact = (firstName, lastName) => {
    contacts.map((con, index) => {
      if (
        con.firstName.toUpperCase().trim() === firstName.toUpperCase().trim() &&
        con.lastName.toUpperCase().trim() === lastName.toUpperCase().trim()
      ) {
        setCheckDuplicateName(true);
      }
      return checkDuplicateContact;
    });
  };

  useEffect(() => {
    // devLog(props);
    onSubmit();
    checkDuplicateContact(props.currState.FirstName, props.currState.LastName);
    // devLog("run useEffect", checkDuplicateName);
  }, []);

  useEffect(() => {
    checkDuplicateContact(props.currState.FirstName, props.currState.LastName);
    // devLog("run useEffect", checkDuplicateName);
  }, [contacts]);

  return (
    <>
      {!loading && (
        <div className="formContainer">
          {/* has account and no error */}
          {memberInfo && !error ? (
            <div className="policyData">
              <div className="policyHeader">
                <h4>{t("description.ContractInformationHeader2")}</h4>
                <hr />
                <div className="policy-info-line">
                  <b>{t("description.Name")}:</b> {memberInfo.Name ? memberInfo.Name : "N/A"}
                </div>
                <hr />
                <div className="policy-info-line">
                  <b>{t("description.ConfirmCustomerPhoneNumber")}:</b>{" "}
                  {memberInfo.phoneNumber ? memberInfo.phoneNumber : "N/A"}
                </div>
                <hr />
                <div className="policy-info-line">
                  <b>{t("CRR.ContractSearch.DropdownOptions3")}:</b>{" "}
                  {memberInfo.memberNumber ? memberInfo.memberNumber : "N/A"}
                </div>
                <hr />
              </div>
              {/*First & Last Name*/}
              <div className="vehicleHeader">
                <h4 className="slim">{t("BWC.PolicyInformation.MemberInformationHeader2")}</h4>
              </div>
              <div className="vehicle-list-container">
                {contacts.map((contact, index) => {
                  return (
                    <>
                      <div
                        value={contact}
                        className={`vehicle-list-item ${selectedMember === contact ? "selected" : ""}`}
                        onClick={(e) => {
                          onSelect(contact);
                        }}
                      >
                        <div value={contact} className="vehicle-list-item-col-1">
                          <h5 value={contact}>
                            {contact.firstName} {contact.lastName}
                          </h5>
                        </div>
                        <input
                          className="vehicleSelector"
                          type="radio"
                          name="policy-vehicle"
                          checked={selectedMember === contact ? "selected" : ""}
                        />
                      </div>
                    </>
                  );
                })}
                {/* <>
                <div
                  key={0}
                  value={memberInfo}
                  className={`vehicle-list-item ${
                    selectedMember === memberInfo ? "selected" : ""
                  }`}
                  onClick={(e) => {
                    onSelect(memberInfo);
                  }}
                >
                  <div value={memberInfo} className="vehicle-list-item-col-1">
                    <h5 value={memberInfo}>{memberInfo.Name}</h5>
                  </div>
                  <input
                    className="vehicleSelector"
                    type="radio"
                    name="policy-vehicle"
                    checked={selectedMember === memberInfo ? "selected" : ""}
                  />
                </div>
              </> */}
              </div>

              {!checkDuplicateName && (
                <>
                  <div className="vehicleHeader">
                    <h4 className="slim">{t("BWC.PolicyInformation.MemberInformationHeader3")}</h4>
                  </div>
                  <div className="vehicle-list-container">
                    <>
                      <div
                        key={0}
                        value={fullNameProps}
                        className={`vehicle-list-item ${selectedMember === fullNameProps ? "selected" : ""}`}
                        onClick={(e) => {
                          onSelectAddNew(fullNameProps);
                        }}
                      >
                        <div value={fullNameProps} className="vehicle-list-item-col-1">
                          <h5 value={fullNameProps}>{fullNameProps}</h5>
                        </div>
                        <input
                          className="vehicleSelector"
                          type="radio"
                          name="policy-vehicle"
                          checked={selectedMember === fullNameProps ? "selected" : ""}
                        />
                      </div>
                    </>
                  </div>
                </>
              )}
            </div>
          ) : (
            <></>
          )}{" "}
          {contacts &&
          !memberInfo &&
          // props.currState.partner === "LMC" &&
          !error ? (
            <div className="policyData">
              <div className="policyHeader">
                <h4>{t("description.ContractInformationHeader2")}</h4>
                <hr />
                <div className="policy-info-line">
                  <b>{t("description.Name")}:</b> N/A
                </div>
                <hr />
                <div className="policy-info-line">
                  <b>{t("description.ConfirmCustomerPhoneNumber")}:</b> N/A
                </div>
                <hr />
                <div className="policy-info-line">
                  <b>{t("CRR.ContractSearch.DropdownOptions3")}:</b> N/A
                </div>
                <hr />
              </div>
              {/*First & Last Name*/}
              <div className="vehicleHeader">
                <h4 className="slim">{t("BWC.PolicyInformation.MemberInformationHeader2")}</h4>
              </div>
              <div className="vehicle-list-container">
                {contacts.map((contact, index) => {
                  return (
                    <>
                      <div
                        // key={0}
                        value={contact}
                        className={`vehicle-list-item ${selectedMember === contact ? "selected" : ""}`}
                        onClick={(e) => {
                          onSelect(contact);
                        }}
                      >
                        <div value={contact} className="vehicle-list-item-col-1">
                          <h5 value={contact}>
                            {contact.firstName} {contact.lastName}
                          </h5>
                        </div>
                        <input
                          className="vehicleSelector"
                          type="radio"
                          name="policy-vehicle"
                          checked={selectedMember === contact ? "selected" : ""}
                        />
                      </div>
                    </>
                  );
                })}
                {/* <>
                <div
                  key={0}
                  value={contacts}
                  className={`vehicle-list-item ${
                    selectedMember === contacts ? "selected" : ""
                  }`}
                  onClick={(e) => {
                    onSelect(contacts);
                  }}
                >
                  <div value={contacts} className="vehicle-list-item-col-1">
                    <h5 value={contacts}>
                      {contacts[0].firstName} {contacts[0].lastName}
                    </h5>
                  </div>
                  <input
                    className="vehicleSelector"
                    type="radio"
                    name="policy-vehicle"
                    checked={selectedMember === contacts ? "selected" : ""}
                  />
                </div>
              </> */}
              </div>

              {/* {fullNameProps.toLowerCase() !==
              memberInfo.Name.toLowerCase() && (
              <>
                <div className="vehicleHeader">
                  <h4 className="slim">
                    {t("BWC.PolicyInformation.MemberInformationHeader3")}
                  </h4>
                </div>
                <div className="vehicle-list-container">
                  <>
                    <div
                      key={0}
                      value={fullNameProps}
                      className={`vehicle-list-item ${
                        selectedMember === fullNameProps ? "selected" : ""
                      }`}
                      onClick={(e) => {
                        onSelectAddNew(fullNameProps);
                      }}
                    >
                      <div
                        value={fullNameProps}
                        className="vehicle-list-item-col-1"
                      >
                        <h5 value={fullNameProps}>{fullNameProps}</h5>
                      </div>
                      <input
                        className="vehicleSelector"
                        type="radio"
                        name="policy-vehicle"
                        checked={
                          selectedMember === fullNameProps ? "selected" : ""
                        }
                      />
                    </div>
                  </>
                </div>
              </>
            )} */}
            </div>
          ) : (
            <></>
          )}
        </div>
      )}
      {/* {error && props.currState.partner === "CIBC" ? ( */}
      {error ? (
        <div className="errorSection">
          <b className="error">{error}</b>
          <div>
            <button className="ui-btn" onClick={onUserBack}>
              {t("description.TryAgain")}
            </button>
          </div>
          <PPUConsentScreen
            onUserBack={onUserBack}
            currState={props.currState}
            partnerCode={props.currState.localGroup}
            context={props.context}
          />
          {/* <div>
            <p>
              Do you agree to let us create a new contact for you and it will
              have 30 days coverage:{" "}
            </p>
            <div style={{ textAlign: "left" }}>
              <label>
                <input
                  type="radio"
                  value="Yes"
                  checked={selectedValue === "Yes"}
                  onChange={handleChange}
                />
                Yes
              </label>
              <div>
                <button
                  className="ui-btn"
                  onClick={onSubmit}
                  onChange={handleChange}
                >
                  Yes
                </button>
              </div>
              <br />
              <div>
                <button
                  className="ui-btn"
                  onClick={onUserBack}
                  onChange={handleChange}
                >
                  No
                </button>
              </div>
            </div>
          </div> */}
        </div>
      ) : (
        <></>
      )}
      {loading ? <PolicyLookupSpinner title={`ContractLookupTitleARI`} message={`PolicyLookupMessage`} /> : <></>}
    </>
  );
}

export default CIBCMemberInformationForm;
